<template>
  <div class="dropdown is-hoverable is-right" :class="$style.container">
    <b-dropdown hoverable aria-role="list" class="is-right">
      <button :class="$style.notificationButton" slot="trigger">
        <b-icon icon="bell" :class="$style.notification"></b-icon>
        <b-tag
          v-if="notificationNumber !== 0"
          :class="$style.tag"
          type="is-danger"
          size="is-small"
        >
          {{ notificationNumber }}
        </b-tag>
        <span v-if="notificationNumber === 0" :class="$style.tag"></span>
      </button>

      <ProjectOwnerRequestNotification
        :notificationInfo="notificationInfo"
        :notificationIds="notificationIds"
        @updateNotificationBell="$emit('updateNotification', $event)"
      />
      <div
        :class="$style.navLinkSection"
        @click="handleNavigateNotifications()"
      >
        <a class="has-text-primary has-text-weight-semibold">
          View All Notifications
        </a>
      </div>
    </b-dropdown>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { get as _get, cloneDeep as _cloneDeep } from 'lodash';
import NotificationBell from 'vue-notification-bell';
import { State, Action } from 'vuex-class';
import { RootState } from '../../store/store';
import { isTruthy } from '../../jbi-shared/util/watcher.vue-decorator';
import ProjectOwnerRequestNotification from '../../views/Project/components/ProjectOwnerRequestNotification.vue';
import { UpdateNewNotificationPayload } from '../../store/modules/notification/types/notification.types';

@Component({
  components: {
    NotificationBell,
    ProjectOwnerRequestNotification,
  },
})
export default class BaseNotificationDropdown extends Vue {
  @Prop() public notificationInfo!: any;
  @Prop() public notificationCount!: number;
  @Prop() public notificationIds!: number[];

  public notificationDetail: any = [];
  public notificationNumber: number = 0;
  public hoverMessage: boolean = false;
  public isViewAllNotification: boolean = false;

  @Action('notifications/updateViewedNotification')
  public updateViewedNotification!: (
    payload: UpdateNewNotificationPayload,
  ) => void;

  @State((state: RootState) => state.notifications.userViewedNotifications)
  public userViewedNotifications!: any;

  public mounted() {
    this.notificationNumber = _cloneDeep(this.notificationCount);
  }

  public handleNavigateNotifications() {
    this.isViewAllNotification = true;
    if (this.notificationIds.length > 0) {
      this.updateViewedNotification({
        notificationIds: this.notificationIds,
      });
    } else {
      this.$router.replace('/notification');
    }
  }

  @Watch('userViewedNotifications')
  @isTruthy
  public watchUserViewedNotification(newValue: any) {
    if (this.$route.path !== '/notification' && this.isViewAllNotification) {
      this.$router.replace('/notification');
    }
  }
}
</script>

<style lang="scss" module>
.container {
  :global {
    .dropdown-menu {
      width: 250%;
    }
    .dropdown-content {
      padding: 0px;
      width: 150%;
    }

    .dropdown-item {
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
}

.navLinkSection {
  border-top: 1px solid $grey-border;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 10px;
  cursor: pointer;
  text-align: left;

  &:hover {
    background-color: #eff7ff;
    cursor: pointer;
  }
}

.navDropdownTrigger {
  &#{&}#{&}#{&}#{&} {
    font-size: 20px;
    text-align: center;
    border-radius: 100%;
    width: 42px;
    height: 42px;
  }
}

.userInfo {
  border-bottom: 1px solid $grey-border;
  padding: 10px 10px 10px;

  .userInfoPrimary {
    color: $grey;
    font-size: 14px;
    font-weight: 700;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .userInfoSecondary {
    color: $grey;
    font-size: 12px;
    font-weight: 400;
    overflow: auto;
    text-align: center;
  }
}
.notificationButton {
  border-color: transparent;
  background-color: white;
  border-width: 1px;
  color: #363636;
  cursor: pointer;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-bottom: calc(0.5em - 1px);
  padding-left: 1em;
  padding-right: 1em;
  padding-top: calc(0.5em - 1px);
  text-align: center;
  white-space: nowrap;
  position: relative;
  bottom: 4px;
}
.notification {
  padding: 30px 10px 0px 30px;
}
.tag {
  right: 0px;
  position: absolute;
}
</style>
